import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import { fetchPromotion, pageNavigation } from '../../actions';
import PromotionFields from './PromotionFields'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import _ from 'lodash';

const propTypes = {
  promotion: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func,
  salesChannels: PropTypes.any,
  discounts: PropTypes.any,
};
const styles = {
  floatingLabelStyle: {
    color: cyan900,
  },
  inputStyle: {
    marginRight: '2%',
    width: '250px',
  },
  datePickerStyle: {
    marginRight: '2%',
    width: '250px',
    float: 'left',
  },
};
class EditPromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        description: null,
        promoCode: null,
        startDate: new Date(),
        endDate: new Date(),
      },
      promotion: {
        name: '',
        description: '',
        promoCode: '',
        startDate: null,
        endDate: null,
        discountId: 0,
        salesChannels: [0],
        maxUses: 0,
        useOnce: false,
        nonBuyer: false,
        disabled: false,
        freeShipping: false,
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let promotion = nextProps.promotion;
    if (nextProps.promotion.id) {
      promotion = nextProps.promotion;
    }
    this.state.endDate = (this.state.promotion.endDate) ? new Date(new Date(this.state.promotion.endDate).setDate(new Date(this.state.promotion.endDate).getDate() + 1)) : new Date(); // eslint-disable-line max-len
    this.state.startDate = (this.state.promotion.startDate) ? new Date(new Date(this.state.promotion.startDate).setDate(new Date(this.state.promotion.startDate).getDate() + 1)) : new Date(); // eslint-disable-line max-len
    promotion.id = (promotion.id === null) ? 0 : promotion.id;
    this.setState({ promotion });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const promotion = this.state.promotion;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = promotion[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDatePickerChange(e, date, target) {
    const nextState = this.state;
    nextState.promotion[target] = date;
    nextState[target] = date;
    nextState.edited = true;
    this.setState(nextState);
    this.setRequiredParams();
  }
  handleSelectChange(event, index, value, t) {
    const promotion = this.state.promotion;
    if (Array.isArray(promotion[t])) {
      (promotion[t].includes(value)) ? _.pull(promotion[t], value) : promotion[t].push(value); // eslint-disable-line
    } else {
      promotion[t] = value;
    }
    this.setState({
      promotion,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const promotion = this.props.promotion;
    if (e.target.type === 'checkbox') {
      _.set(promotion, e.target.name, e.target.checked);
    } else {
      _.set(promotion, e.target.name, e.target.value);
    }
    this.setState({
      promotion,
      edited: true,
    });
    this.setRequiredParams();
  }
  navigateToView() {
    this.props.dispatch(pageNavigation('view'))
    this.props.dispatch(fetchPromotion(this.props.promotion.id));
    // if (this.state.edited === true) {
    //   const nextState = this.state;
    //   nextState.viewRedirect = true;
    //   this.setState(nextState);
    //   this.handleOpen();
    // } else {
      // browserHistory.push(`/promotions/view/${this.state.promotion.id}`);
    // }
  }
  navigateToEdit() {
    this.props.dispatch(pageNavigation('edit'))
    //browserHistory.push(`/promotions/${this.state.promotion.id}`);
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      this.props.dispatch(pageNavigation('view'))
      //browserHistory.push(`/promotions/view/${this.state.promotion.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Promotion Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this promotion?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.promotion.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.promotion);
        break;
      default:
        this.props.onSave(this.state.promotion);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/promotions?page=1');
  }
  render() {
    const isTrue = true;
    const salesChannels = this.props.promotion.salesChannels;
    const discountSelect = _.map(this.props.discounts, d => <MenuItem value={d.id} key={d.id} primaryText={d.name} />);
    const scSelect = _.map(this.props.salesChannels, sc => <MenuItem
      value={sc.id}
      key={sc.id}
      label={sc.name}
      primaryText={sc.name}
      checked={salesChannels && salesChannels.includes(sc.id)}
    />)
    return (
      <div style={{ width: '100%' }}>
        { !this.props.navigationType ? <h2>Edit Promotion</h2> : <h2>View Promotion</h2> }
        <div className="content">
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.saveChanges()}
          dialogTitle={this.state.dialogTitle}
          dialogMessage={this.state.dialogMessage}
          dialogActionTitle={this.state.dialogActionTitle}
        />
        {!this.props.navigationType ?
        <div className="float-right">
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="View"
            primary
            onClick={this.navigateToView}
          />
          <RaisedButton
            label="Save"
            primary
            onClick={this.handleOpen}
          />
          </div>
          :
          <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
          </div>
          }
        <br />
        <PromotionFields 
        promotion = {this.props.promotion}
        styles={styles}
        handleChange = {this.handleChange}
        errorText = {this.state.required}
        handleDatePickerChange = {this.handleDatePickerChange}
        handleSelectChange = {this.handleSelectChange}
        startDate={this.state.startDate} 
        endDate={this.state.endDate}
        isTrue={isTrue}
        salesChannels={salesChannels}
        disablePromotion={this.state.promotion.disabled}
        useOnce= {this.state.promotion.useOnce}
        nonBuyer= {this.state.promotion.nonBuyer}
        discountId= {this.state.promotion.discountId}
        discountSelect={discountSelect}
        scSelect={scSelect}
        disableFields= {this.props.navigationType}
        freeShipping={this.props.promotion.freeShipping}
        />
      </div>
      </div>
    );
  }
}

EditPromotion.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditPromotion.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    promotion: state.promotions.promotion,
    salesChannels: state.salesChannels.results,
    discounts: state.discounts.results,
    navigationType: state.admins.navigationType
  };
}

export default connect(mapStateToProps)(EditPromotion);



// WEBPACK FOOTER //
// ./src/components/promotions/EditPromotion.js